import React from "react";
import styles from "../styles/section-title.module.css";

function SectionTitle(props) {
    const section = props.section;
    if (section === "squirrels") {
        return (
            <section className={styles.sectionTitle}>
                <img src={`${process.env.PUBLIC_URL}/images/squirrels.png`} alt="Squirrels" />
                <p>4 - 6 Year Olds</p>
                <p>Monday, 16:30 - 17:30</p>
                <p>Term Time</p>
            </section>
        );
    } else if (section === "beavers") {
        return (
            <section className={styles.sectionTitle}>
                <img src={`${process.env.PUBLIC_URL}/images/beavers.png`} alt="Beavers" />
                <p>6 - 8 Year Olds</p>
                <p>Friday, 18:00 - 19:15</p>
                <p>Term Time</p>
            </section>
        );
    } else if (section === "cubs") {
        return (
            <section className={styles.sectionTitle}>
                <img src={`${process.env.PUBLIC_URL}/images/cubs.png`} alt="Cubs" />
                <p>8 - 10 Year Olds</p>
                <p>Thursday, 18:45 - 20:15</p>
                <p>Term Time</p>
            </section>
        );
    } else if (section === "scouts") {
        return (
            <section className={styles.sectionTitle}>
                <img src={`${process.env.PUBLIC_URL}/images/scouts.png`} alt="Scouts" />
                <p>10 - 14 Year Olds</p>
                <p>Monday, 19:00 - 20:30</p>
                <p>Term Time</p>
            </section>
        );
    } else {
        return (
            <section className={styles.sectionTitle}>
                <h1>Welcome to the Default section!</h1>
            </section>
        )
    }
}

export default SectionTitle;
